import { Typography, Card, Button, Row, Col, Select, Badge, Divider } from "antd";
import { EXECUTION_STATUS } from "common/Constants";
import moment from "moment";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const { Text } = Typography;

const OnGoingDeployments = ({
  onGoingExecution,
  jobDocument,
  selectedExecutionStatus,
  setSelectedExecutionStatus,
  setSelectedsignal,
  setFetchJobDocument,
  updateJobMQTTProcess,
  updateExecutionSignal
}) => {

  return Object.keys(onGoingExecution).length > 0 && <Badge.Ribbon text={onGoingExecution?.status} color={onGoingExecution?.status === EXECUTION_STATUS.IN_PROGRESS ? 'orange' : 'blue'}>
    <Card style={{ marginBottom: '4%', marginTop: '4%', textAlign: 'center' }}>
      <div style={{ textAlign: 'left', marginBottom: '5%' }}>
        <p >Deployment ID: {onGoingExecution?.deploymentId}</p>
        <p >Execution ID: {onGoingExecution?.executionId}</p>
        <p >Created {moment(onGoingExecution?.startedAt).fromNow()}</p>
        <p >Queued {moment(onGoingExecution?.queuedAt).fromNow()}</p>
      </div>
      {Object.keys(jobDocument).length === 0 ?
        <Button
          onClick={() => setFetchJobDocument(true)}
        >
          Get Job Document
        </Button>
        :
        <>
          <div style={{
            display: 'flex', justifyContent: 'start', marginBottom: '2%'
          }}>
            <p>
              Fetching Job Document
            </p >
            <Button style={{ marginLeft: '2%' }} type="primary" icon={<FaCheckCircle />} size={'small'} />
          </div>
          {jobDocument?.releaseData?.[0]?.manifest_url && <Text style={{
            display: 'flex', justifyContent: 'start', marginBottom: '3%'
          }}>
            Validating Manifest URL
            <Button style={{ marginLeft: '2%' }} type="primary" icon={<FaCheckCircle />} size={'small'} />
          </Text >}
          {jobDocument?.releaseData?.[0]?.download_url && <Text style={{
            display: 'flex', justifyContent: 'start', marginBottom: '5%'
          }}>
            Validating Image Download URL
            <Button style={{ marginLeft: '2%' }} type="primary" icon={<FaCheckCircle />} size={'small'} />
          </Text >}
          <Row>


            {jobDocument && <>
              <Divider dashed />
              <Select
                placeholder='Choose Execution Status'
                options={[
                  { value: 'IN_PROGRESS', label: 'IN_PROGRESS' },
                  { value: 'SUCCEEDED', label: 'SUCCEEDED' },
                  { value: 'FAILED', label: 'FAILED' },
                ]}
                value={selectedExecutionStatus}
                onChange={(v) => setSelectedExecutionStatus(v)}
              />
              <Button
                disabled={selectedExecutionStatus ? false : true}
                style={{ marginLeft: '3%' }}
                type="primary"
                onClick={() => updateJobMQTTProcess(selectedExecutionStatus)}
              >
                Update Job Execution
              </Button>
              <Divider dashed />
              <Select
                onChange={(v) => setSelectedsignal(v)}
                placeholder="Choose Execution Signal"
                options={[
                  {
                    label: <span>In Progress</span>,
                    title: 'In Progress',
                    options: [
                      { label: <span>VERSION_COMPATIBLE</span>, value: 'VERSION_COMPATIBLE' },
                      { label: <span>DOWNLOAD_CONSENT_POPUP_SHOWN</span>, value: 'DOWNLOAD_CONSENT_POPUP_SHOWN' },
                      { label: <span>INSTALL_CONSENT_POPUP_SHOWN</span>, value: 'INSTALL_CONSENT_POPUP_SHOWN' },
                      { label: <span>INSTALLATION_PRECONDITION_MET</span>, value: 'INSTALLATION_PRECONDITION_MET' },
                      { label: <span>USER_DEFERRED_INSTALL</span>, value: 'USER_DEFERRED_INSTALL' },
                      { label: <span>USER_ACCEPTS_INSTALL</span>, value: 'USER_ACCEPTS_INSTALL' },
                      { label: <span>USER_ACCEPTS_DOWNLOAD</span>, value: 'USER_ACCEPTS_DOWNLOAD' },
                      { label: <span>DATA_SETTING_DISABLED_ON_WIFI</span>, value: 'DATA_SETTING_DISABLED_ON_WIFI' },
                      { label: <span>DATA_SETTING_ENABLED_ON_WIFI</span>, value: 'DATA_SETTING_ENABLED_ON_WIFI' },
                      { label: <span>RESUME_DOWNLOADING</span>, value: 'RESUME_DOWNLOADING' },
                      { label: <span>USER_DEFERRED_DOWNLOAD</span>, value: 'USER_DEFERRED_DOWNLOAD' },
                      { label: <span>ALL_FILES_DOWNLOADED</span>, value: 'ALL_FILES_DOWNLOADED' },
                      { label: <span>VERIFICATION_STARTED</span>, value: 'VERIFICATION_STARTED' },
                      { label: <span>VERIFICATION_SUCCESS</span>, value: 'VERIFICATION_SUCCESS' },
                    ],
                  },
                  {
                    label: <span>Succeeded</span>,
                    title: 'Succeeded',
                    options: [
                      { label: <span>INSTALLATION_SUCCESS</span>, value: 'INSTALLATION_SUCCESS' },
                      { label: <span>VERSION_MATCHED</span>, value: 'VERSION_MATCHED' },
                    ],
                  },
                  {
                    label: <span>Rejected</span>,
                    title: 'Rejected',
                    options: [
                      { label: <span>VERSION_CHECK_DISABLED</span>, value: 'VERSION_CHECK_DISABLED' },
                      { label: <span>VERSION_NOT_UPGRADABLE</span>, value: 'VERSION_NOT_UPGRADABLE' },
                      { label: <span>VERSION_NOT_COMPATIBLE</span>, value: 'VERSION_NOT_COMPATIBLE' },
                    ],
                  },
                  {
                    label: <span>Failed</span>,
                    title: 'Failed',
                    options: [
                      { label: <span>INSTALLATION_PRECONDITION_NOT_MET</span>, value: 'INSTALLATION_PRECONDITION_NOT_MET' },
                      { label: <span>STORAGE_SPACE_INSUFFICIENT</span>, value: 'STORAGE_SPACE_INSUFFICIENT' },
                      { label: <span>VERIFICATION_FAILED</span>, value: 'VERIFICATION_FAILED' },
                      { label: <span>DOWNLOAD_FAILED</span>, value: 'DOWNLOAD_FAILED' },
                      { label: <span>INSTALLATION_FAILED</span>, value: 'INSTALLATION_FAILED' },
                    ],
                  },
                ]}
              />

              <Button style={{ marginLeft: '3%' }} type="primary" onClick={() => updateExecutionSignal()}>
                Update Execution Signal
              </Button>
            </>}
          </Row>
        </>
      }


    </Card>
  </Badge.Ribbon>
}

export default OnGoingDeployments;